import { MessageError } from "@/types/messages";

export class MessageErrorHandler {
    private static readonly ERROR_CODES = {
      NETWORK_ERROR: 'message/network-error',
      PERMISSION_DENIED: 'message/permission-denied',
      MESSAGE_TOO_LONG: 'message/content-too-long',
      RATE_LIMIT: 'message/rate-limit',
      INVALID_CONTENT: 'message/invalid-content',
    };
  
    static handleMessageError(error: any): MessageError {
      const timestamp = Date.now();
  
      // Handle Firebase specific errors
      if (error.code?.startsWith('firebase/')) {
        switch (error.code) {
          case 'firebase/permission-denied':
            return {
              code: this.ERROR_CODES.PERMISSION_DENIED,
              message: 'You do not have permission to send messages in this conversation',
              timestamp,
            };
          case 'firebase/network-request-failed':
            return {
              code: this.ERROR_CODES.NETWORK_ERROR,
              message: 'Unable to send message due to network issues. Please try again.',
              timestamp,
            };
          default:
            return {
              code: error.code,
              message: error.message || 'An unknown error occurred',
              timestamp,
            };
        }
      }
  
      // Handle custom validation errors
      if (error.type === 'validation') {
        switch (error.code) {
          case 'message-too-long':
            return {
              code: this.ERROR_CODES.MESSAGE_TOO_LONG,
              message: 'Message exceeds maximum length of 1000 characters',
              timestamp,
            };
          case 'rate-limit':
            return {
              code: this.ERROR_CODES.RATE_LIMIT,
              message: 'Please wait a few seconds before sending another message',
              timestamp,
            };
          default:
            return {
              code: this.ERROR_CODES.INVALID_CONTENT,
              message: 'Message contains invalid content',
              timestamp,
            };
        }
      }
  
      // Default error
      return {
        code: 'message/unknown-error',
        message: 'An unexpected error occurred. Please try again.',
        timestamp,
      };
    }
  
    static isRetryableError(error: MessageError): boolean {
      return [
        this.ERROR_CODES.NETWORK_ERROR,
        'message/unknown-error'
      ].includes(error.code);
    }
  }